import { IntegrationCell } from '@/components/common/items-data-table/cells/IntegrationCell';
import type { ItemTypeMap } from '@/lib/api/types/itemType';
import { useVisibleIntegration } from '../context/VisibleIntegrationsContext';
import type { ItemsTableRow } from '../types';
import { CellTextSkeleton } from './withSkeleton';

export const IntegrationDataGridCell = ({
  row,
  itemTypesById,
  canEditIntegrations,
}: {
  row: ItemsTableRow;
  itemTypesById: ItemTypeMap;
  canEditIntegrations: boolean;
}) => {
  const visible = useVisibleIntegration(row.id);
  if (visible === undefined) return <CellTextSkeleton />;

  const itemLevelId = row.itemTypeId ? itemTypesById[row.itemTypeId]?.itemLevelId : undefined;

  return (
    <IntegrationCell
      itemId={row.id}
      integration={visible.integration}
      itemLevelId={itemLevelId}
      syncStatus={visible.syncStatus}
      canEditIntegrations={canEditIntegrations}
    />
  );
};
